<app-table [useFixedHeader]="fixedHeader">
  <app-table-headers>
    <ng-container *ngIf="showAccountId">
      <app-table-header class="icon-cell justify-content-center buttons">
      </app-table-header>
      <app-table-header class="flex">Account ID</app-table-header>
    </ng-container>
    <app-table-header class="flex">Pro Account ID</app-table-header>
    <app-table-header class="flex-half">Section ID</app-table-header>
    <app-table-header class="flex flex-center">
      {{ showAccountId ? 'Last run PAS' : 'Status' }}
    </app-table-header>
    <app-table-header class="flex">Last run</app-table-header>
    <app-table-header class="flex">Last run Reccuring</app-table-header>
    <app-table-header class="flex">Initial OK</app-table-header>
    <app-table-header class="flex">Initial FAIL</app-table-header>
    <app-table-header
      *ngIf="showLogButtons"
      class="icon-cell justify-content-center buttons"
    ></app-table-header>
  </app-table-headers>

  <ng-template #empty>
    <app-table-content-empty [isLoading]="isLoadingAccounts">
      <ng-container loading
        ><p>Fetching account migrations ...</p></ng-container
      >

      <ng-container nodata *ngIf="!isLoadingAccounts">
        <p>No migrations found</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content *ngIf="!isLoadingAccounts; else empty">
    <ng-container *ngIf="migrations && migrations.length; else empty">
      <app-table-row
        *ngFor="
          let migration of migrations
            | searchPipe: searchQuery:'oneAccountId':stateFilter
        "
        [class.error]="!migration.oneAccountId"
      >
        <ng-container *ngIf="showAccountId">
          <app-table-cell class="icon-cell justify-content-center buttons">
            <div [ngbTooltip]="'See details'">
              <button
                routerLink="/migrations/{{ migration.oneAccountId }}/{{
                  migration.proAccountId
                }}"
                class="btn btn-sm btn-primary file"
              >
                <i class="fas fa-directions"></i>
              </button>
            </div>
          </app-table-cell>
          <app-table-cell class="flex">
            <strong>{{ migration.oneAccountId }}</strong>
          </app-table-cell>
        </ng-container>
        <app-table-cell class="flex">
          <strong>{{ migration.proAccountId }}</strong>
        </app-table-cell>
        <app-table-cell class="flex-half">
          <strong>{{ migration.sectionId }}</strong>
        </app-table-cell>
        <app-table-cell class="flex flex-center">
          <span
            [ngClass]="
              'badge badge-' + getMigrationStateClass(migration.status)
            "
          >
            {{ migration.status }}
          </span>
        </app-table-cell>
        <app-table-cell class="flex flex-center">
          {{ getLastSync(migration) | date: 'yyyy-MM-dd' }}
          <br />
          {{ getLastSync(migration) | date: 'HH:mm' }}
        </app-table-cell>
        <app-table-cell class="flex">
          subscribers:
          <b>{{ migration.order?.results?.subscribers?.synced }}</b>
          <br />
          subscriptions:
          <b>
            {{ migration.order | subscriptionsPipe: 'synced' }}
          </b>
          <br />
          OOA:
          <b>{{ migration.order?.results?.optOutAll?.synced }} </b>
          <br />
          OOL OK:
          <b>
            {{ migration.order | subscriptionsPipe: 'optOutListSynced' }}
          </b>
          <br />
          OOL Fail:
          <b>
            {{ migration.order | subscriptionsPipe: 'optOutListSyncFailed' }}
          </b>
        </app-table-cell>
        <app-table-cell class="flex">
          subscribers:
          <b>{{ migration.order?.results?.subscribers?.succeeded }}</b>
          <br />
          subscriptions:
          <b>
            {{ migration.order | subscriptionsPipe: 'succeeded' }}
          </b>
          <br />
          OOA:
          <b>{{ migration.order?.results?.optOutAll?.succeeded }} </b>
          <br />
          OOL:
          <b>
            {{ migration.order | subscriptionsPipe: 'optOutListSucceeded' }}
          </b>
        </app-table-cell>
        <app-table-cell class="flex">
          subscribers:
          <b>{{ migration.order?.results?.subscribers?.failed }}</b>
          <br />
          subscriptions:
          <b>
            {{ migration.order | subscriptionsPipe: 'failed' }}
          </b>
          <br />
          OOA:
          <b>{{ migration.order?.results?.optOutAll?.failed }} </b>
          <br />
          OOL:
          <b>
            {{ migration.order | subscriptionsPipe: 'optOutListFailed' }}
          </b>
        </app-table-cell>
        <ng-container *ngIf="showLogButtons">
          <app-table-cell class="icon-cell justify-content-center buttons">
            <div [ngbTooltip]="'Export migration log'">
              <button
                class="btn btn-sm btn-primary file"
                (click)="getMigrationReport.emit(migration)"
              >
                <i class="fas fa-file-alt icon"></i>
              </button>
            </div>
            <div [ngbTooltip]="'Migration as JSON'">
              <button
                class="btn btn-sm btn-primary"
                (click)="openMigrationModal.emit(migration)"
              >
                <i class="fas fa-code icon"></i>
              </button>
            </div>
          </app-table-cell>
        </ng-container>
      </app-table-row>
    </ng-container>
  </app-table-content>
</app-table>
